
import React from 'react';
import { ChevronRight, Star } from 'lucide-react';

const ClientChatCard = ({ chat, onClick }) => {

    const clientDetails = chat.participantDetails && chat.clientId
        ? chat.participantDetails[chat.clientId]
        : null;

    const clientName = clientDetails?.name || 'Cliente Desconhecido';
    const clientPhotoUrl = clientDetails?.photoUrl || `https://ui-avatars.com/api/?name=${clientName.replace(/ /g, '+')}&background=E0E0E0&color=757575`;

    const formatDate = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '';
        return date.toLocaleDateString('pt-BR');
    };

    const statusConfig = {
        'Novo': { text: 'Novo', color: '#3B82F6' },
        'Orçamento Enviado': { text: 'Orçamento Enviado', color: '#F59E0B' },
        'Agendamento': { text: 'Agendamento', color: '#8B5CF6' },
        'Em Andamento': { text: 'Em Andamento', color: '#10B981' },
        'Aguardando Pagamento': { text: 'Pagamento', color: '#F59E0B' },
        'Finalizado': { text: 'Finalizado', color: '#6B7280' },
    };
    const currentStatus = statusConfig[chat.status] || { text: chat.status, color: '#6B7280' };

    return (
        <div onClick={onClick} className="bg-white rounded-xl shadow-md overflow-hidden flex items-stretch mb-3 cursor-pointer transition-transform hover:scale-[1.02] active:scale-[0.98]">
            <div style={{ backgroundColor: currentStatus.color }} className="w-2 flex-shrink-0"></div>
            <div className="flex-grow flex items-center justify-between p-4">
                <div className="flex items-center min-w-0">
                    {/* FOTO SQUIRCLE */}
                    <div className="w-12 h-12 rounded-xl overflow-hidden bg-white border border-gray-100 shadow-sm flex items-center justify-center p-0.5 mr-4 flex-shrink-0">
                        <img src={clientPhotoUrl} alt={clientName} className="w-full h-full object-contain rounded-lg" />
                    </div>

                    <div className="min-w-0">
                        <div className="flex items-center">
                            <h3 className="font-bold text-gray-800 text-lg truncate mr-2">{clientName}</h3>
                            {chat.clientRating && (
                                <div className="flex items-center bg-yellow-50 px-1.5 py-0.5 rounded border border-yellow-100 flex-shrink-0">
                                    <Star size={10} className="text-yellow-500 fill-current mr-1" />
                                    <span className="text-[10px] font-black text-yellow-700">{chat.clientRating.toFixed(1)}</span>
                                </div>
                            )}
                        </div>
                        <p className="text-sm font-semibold text-gray-600 truncate">{chat.serviceTitle || 'Serviço'}</p>
                        {chat.clientTopTag && (
                            <p className="text-[10px] font-bold text-blue-500 uppercase tracking-tighter mt-0.5">{chat.clientTopTag}</p>
                        )}
                        <p className="text-xs text-gray-500 mt-1 truncate">{chat.lastMessage}</p>
                    </div>
                </div>
                <div className="flex flex-col items-end ml-4 flex-shrink-0">
                    <span className="text-xs text-gray-400 font-medium">{formatDate(chat.lastMessageTimestamp)}</span>
                    <ChevronRight className="w-6 h-6 text-gray-300 mt-2" />
                </div>
            </div>
        </div>
    );
};

export default ClientChatCard;
